import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { onboardingCompleted } from '../../../store/ducks/user';

class SkipLink extends Component {
  onSkip = () => {
    this.props.skipPayment(this.props.connectedProduct);
  }

  render() {
    if (this.props.app === 'wolf') return null;

    return <a className="plan-selection-skip" onClick={ this.onSkip }>Skip</a>;
  }
}

SkipLink.propTypes = {
  app: PropTypes.string.isRequired,
  connectedProduct: PropTypes.string,
  skipPayment: PropTypes.func.isRequired
};

export default connect(
  state => ({
    connectedProduct: state.connectedProduct
  }),
  dispatch => ({
    skipPayment: connectedProduct => dispatch(onboardingCompleted(connectedProduct))
  })
)(SkipLink);
